import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SharedModule } from './components/common/common.module';
import { NgxSpinnerModule } from "ngx-spinner";
import { LayoutComponent } from './components/layout/layout.component';
import { GeneralDataComponent } from './components/general-data/general-data.component';
import { OptionsComponent } from './components/options/options.component';
import { IdentificationComponent } from './components/identification/identification.component';
import { ProfAddressComponent } from './components/prof-address/prof-address.component';
import { AssistedOpeningComponent } from './components/assisted-opening/assisted-opening.component';
import { AdditionalDataComponent } from './components/additional-data/additional-data.component';
import { BeneficiaryComponent } from './components/beneficiary/beneficiary.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { AutonomousOpeningComponent } from './components/autonomous-opening/autonomous-opening.component';

@NgModule({
  declarations: [
    AppComponent,
    LayoutComponent,
    GeneralDataComponent,
    OptionsComponent,
    IdentificationComponent,
    ProfAddressComponent,
    AssistedOpeningComponent,
    AdditionalDataComponent,
    BeneficiaryComponent,
    ConfirmationComponent,
    AutonomousOpeningComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    NgbModule,
    SharedModule,
    NgxSpinnerModule,
    BrowserAnimationsModule
  ],
  providers: [],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
